<div class="ai-floating" [class.is-open]="open()">
  <button
    type="button"
    class="ai-floating__launcher"
    *ngIf="!open()"
    (click)="toggleOpen()"
  >
    <span class="ai-floating__dot"></span>
    <span>Chat with AI</span>
  </button>

  <section class="ai-floating__panel" *ngIf="open()" @panelAnimation>
    <header class="ai-floating__header">
      <div>
        <h3>AI Booking Assistant</h3>
        <p>Find salons, services, staff, and times.</p>
      </div>

      <button type="button" class="ai-floating__close" (click)="close()">
        x
      </button>
    </header>

    <div class="ai-floating__body">
      <app-ai-booking-card
        [locationQuery]="locationQuery"
        [isAuthenticated]="isAuthenticated"
      ></app-ai-booking-card>
    </div>
  </section>
</div>
